import { HighlightMessageCombinedProps } from './types';

const usePresenter = (props: HighlightMessageCombinedProps): HighlightMessageCombinedProps => {
  return props;
};

export default usePresenter;
